module.exports = __webpack_public_path__ + "img/tiktok.88c613be.svg";